import { Button, ButtonProps } from '@lifeomic/chroma-react/components/Button';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import * as React from 'react';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  root: {
    fontSize: theme.typography.subtitle1.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    padding: 0,
  },
  rootNotSelected: {
    color:
      theme.palette.mode === 'dark'
        ? theme.palette.text.secondary
        : theme.palette.black.main,
    '&:hover': {
      color:
        theme.palette.mode === 'dark'
          ? theme.palette.text.primary
          : theme.palette.black[600],
    },
    '&:disabled': {
      color:
        theme.palette.mode === 'dark'
          ? theme.palette.text.disabled
          : theme.palette.black.main,
    },
  },
}));

interface ListItemProps {
  className?: string;
  disabled?: boolean;
  isSelected?: boolean;
  onClick?: ButtonProps['onClick'];
}

export const ListItem: React.FC<ListItemProps> = ({
  className,
  children,
  disabled = false,
  isSelected = false,
  onClick,
}) => {
  const classes = useStyles({});
  return (
    <Button
      className={clsx(
        classes.root,
        !isSelected && classes.rootNotSelected,
        className,
      )}
      role="tab"
      disabled={disabled}
      aria-selected={isSelected}
      variant="text"
      onClick={onClick}
    >
      {children}
    </Button>
  );
};
